import React, { useState } from "react"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import useReportFiltersContext from "../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import ClientChip from "../../../../components/molecules/ClientChip.molecule"
import MyRangePicker from "../../../../components/atoms/RangePicker.atoms"
import { DateTime } from "luxon"

function ModalDownloadPeriodTasks({ visible, setVisible, downloadRangeTasks }) {
  const [loading, setLoading] = useState(false)
  const [dateRange, setDateRange] = useState([DateTime.now(), DateTime.now()])

  const { clientReportSelectedClientCode, clientReportSelectedClientName } =
    useReportFiltersContext()

  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      cleanUp={() => setDateRange([DateTime.now(), DateTime.now()])}
      saveLabel="Aceptar"
      header={
        <div className="flex gap-3 align-items-center">
          <i
            className="pi pi-download text-4xl"
            style={{ color: "var(--clr-info__dark)" }}
          />
          <div className="flex flex-column gap-2 ">
            <span
              className="text-3xl font-cairo line-height-1"
              style={{ fontWeight: 500 }}
            >
              Descargar tareas
            </span>
            <div
              className="flex gap-2 align-items-center font-cairo"
              style={{ fontWeight: "600" }}
            >
              <ClientChip clientCode={clientReportSelectedClientCode} />
              {clientReportSelectedClientName}
            </div>
          </div>
        </div>
      }
      service={async () => {
        setLoading(true)
        await downloadRangeTasks(dateRange[0], dateRange[1])
        setDateRange([DateTime.now(), DateTime.now()])
        setLoading(false)
        setVisible(false)
      }}
      loading={loading}
      //   disabledSaveBtn={fieldsHaveErrors(validations)}
    >
      <div className="flex flex-column gap-2">
        <label
          htmlFor="range-picker-download-period-tasks"
          style={{
            color: "light-dark(var(--secondary-color-dark__dark), white)",
          }}
        >
          Rango de fechas
        </label>
        <MyRangePicker
          id="range-picker-download-period-tasks"
          className="download-period-tasks-range-picker"
          inputReadOnly
          allowClear={false}
          value={dateRange}
          onChange={setDateRange}
          format={"DD/MM/YYYY"}
          separator={<p className="clr-secondary">-</p>}
        />
      </div>
    </ModalForm>
  )
}

export default ModalDownloadPeriodTasks
